import { Row, Col, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { useNavigate as useHistory } from 'react-router-dom';

function GeografieEuropeeClassificazioni({ isMobile }) {
  const history = useHistory();

  useEffect(() => {
    document.title = 'Geografie europee e relative classificazioni - SITUAS';
  });

  return (
    <div>
      <button
        tabIndex="0"
        aria-hidden="arrow-left"
        id="TornaIndietro-btn"
        onClick={() => {
          history(`/home`);
        }}>
        <ArrowLeftOutlined />
        <span>Indietro</span>
      </button>

      {/* FASE 3 - BOX OSCURATO
      <Row className="box">
        <Col xs={24}>
          <h2 className="title-main">Geografie europee e relative classificazioni</h2>
          <Divider className="blue-divider" />
          <div>
            L’Unione europea ha istituito una Nomenclatura delle unità territoriali statistiche,
            denominata «Nuts», per permettere la rilevazione, la compilazione e la diffusione di
            statistiche regionali armonizzate nell’Ue. Questo sistema gerarchico, che in Italia
            ricalca i concetti di uts (provincia, città metropolitana, ecc.), regione e ripartizione
            geografica, viene anche utilizzato per condurre analisi socioeconomiche nelle regioni ed
            elaborare gli interventi nel contesto della politica di coesione dell’Ue. La
            classificazione della Nuts viene aggiornata con cadenza triennale tramite regolamento Ue.
          </div>

          <div
            className={`d-flex pt-5 justify-content-around codifiche`}
            style={{ columnGap: '15px', rowGap: '10px' }}>
            <div
              className="py-2 px-3 card d-flex flex-column">
              A partire dal 2006 è possibile consultare la lista delle Nuts vigenti ad un certo anno o
              confrontarne le diverse versioni
              <div className="mt-auto">
                <Link className="box-linkto" to="/territorio">
                  Vai alla sezione Unità territoriali
                </Link>
              </div>
            </div>
            <div
              className="py-2 px-3 card d-flex flex-column">
              Per le classificazioni delle Nuts consultare il link
              <div className="mt-auto">
                <Link className="box-linkto" to="/territorio">
                  Vai alla sezione Unità territoriali
                </Link>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      */}
    </div>
  );
}
export default GeografieEuropeeClassificazioni;
